import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import Delete from "./Delete";
import Create from "./Create";
import Update from "./Update";
import { useGetCourseQuery } from "../../../Services/api";
import {pageUrl,pageSize} from "../../../utils/constants/constants";
export default function Index() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getCourse,
        isLoading: isGetLoading,
      } = useGetCourseQuery({ pageUrl, params:  {search,page,pageSize}  });
       
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      const [courseId,setCourseId] = useState("");
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Manage Course</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Course List</button>
                        </li>
                        <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Course Add</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">Course List</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>course group</th>
                                                                <th className='text-capitalize'>course name</th>
                                                                <th className='text-capitalize'>short name</th>
                                                                <th className='text-capitalize'>course type</th>
                                                                <th className='text-capitalize'>course image</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getCourse?.data?.data_array?.map((item) => {
                                                            return (
                                                                <tr key={item.course_id}>
                                                                    <th scope="row">{item.course_id}</th>
                                                                    <td>{item.course_qualification?.qualification}</td>
                                                                    <td>{item.course_name}</td>
                                                                    <td>{item.short_name}</td>
                                                                    <td>{item.course_type==1 ? 'Paid':' Free'}</td> 
                                                                    <td>{item.course_type ==1 ? <img src={item.course_image} height="50" width="50"/>:item.Course_link}</td>
                                                                    <td>
                                                                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                            
                                                                            <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setCourseId(item.course_id)} data-id={item.course_id} data-bs-target="#fullscreenModal" >
                                                                                <div className="icon text-info">
                                                                                <i className="bi bi-pencil-square"></i>
                                                                                    Update
                                                                                </div>
                                                                            </button>
                                                                            
                                                                            <Delete id={item.course_id} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    </td>                                                                    
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getCourse?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getCourse?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getCourse?.data?.totalPages}</li>
                                                    {getCourse?.data?.currentPage !==getCourse?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                        <Update id={courseId}/>
                        <Create />
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
